import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Tag } from 'src/shared/components/tag';
export function TagList() {
    const { t } = useTranslation();
    const form = useFormContext();
    const tags = form.watch('tags');
    function handleRemove(index) {
        form.setValue('tags', tags.filter((_, tagIndex) => tagIndex !== index), { shouldDirty: true });
    }
    return (_jsx("div", { className: "flex flex-wrap gap-2", children: tags.map((tag, index) => (_jsxs(Tag, { context: "neutral", variation: "secondary", style: { '--hc-tag-gap': 'var(--spacer-2)' }, children: [tag, _jsx("button", { className: "bg-transparent m-0 appearance-none border-none p-0", type: "button", onClick: () => handleRemove(index), "aria-label": t('content.form.search_tags.remove', { tag }), children: _jsx(FontAwesomeIcon, { icon: faTimes }) })] }, `${tag}${index}`))) }));
}
